import { render, staticRenderFns } from "./view-case-record-request.vue?vue&type=template&id=70458536&"
import script from "./view-case-record-request.vue?vue&type=script&lang=js&"
export * from "./view-case-record-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports